import { createContext, useContext, useState, useMemo, useEffect } from "react";

import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

const UIContext = createContext(null);

export const UIProvider = ({ children }) => {
  const [sideMenuOpen, setSideMenuOpen] = useState(true);
  const [showFooter, setShowFooter] = useState(true);
  const [showCrumbs, setShowCrumbs] = useState(true);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    if (isMobile) return;
    let lastWidth = window.innerWidth;

    const handleResize = () => {
      const currentWidth = window.innerWidth;

      // Bail if width didn't change
      if (currentWidth === lastWidth) return;

      lastWidth = currentWidth;

      if (currentWidth < 1080) setSideMenuOpen(false);
      else setSideMenuOpen(true);
    };

    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const value = useMemo(
    () => ({
      sideMenuOpen,
      setSideMenuOpen,
      showFooter,
      setShowFooter,
      showCrumbs,
      setShowCrumbs,
      theme,
      isMobile,
    }),
    [sideMenuOpen, showFooter, showCrumbs, theme, isMobile]
  );

  return <UIContext.Provider value={value}>{children}</UIContext.Provider>;
};

export const useUI = () => {
  const context = useContext(UIContext);
  if (!context) {
    // FIX: Updated error message to reflect the actual Context name
    throw new Error("useUI must be used within a UIProvider");
  }
  return context;
};
